var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6864 15.0847C24.6927 15.0847 25.5084 14.269 25.5084 13.2627C25.5084 12.2564 24.6927 11.4407 23.6864 11.4407C22.6801 11.4407 21.8644 12.2564 21.8644 13.2627C21.8644 14.269 22.6801 15.0847 23.6864 15.0847Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6864 15.0847C24.6927 15.0847 25.5084 14.269 25.5084 13.2627C25.5084 12.2564 24.6927 11.4407 23.6864 11.4407C22.6801 11.4407 21.8644 12.2564 21.8644 13.2627C21.8644 14.269 22.6801 15.0847 23.6864 15.0847Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5756 16.0393C24.0654 16.1997 23.5042 16.2288 22.9212 16.0831C21.9446 15.828 21.1502 15.0482 20.8805 14.0715C20.7493 13.5978 20.742 13.1314 20.8222 12.7087C20.9169 12.2422 20.589 11.8049 20.1225 11.8049H14.5763C12.3898 11.8049 10.9322 12.8982 10.9322 15.449V20.5507C10.9322 23.1015 12.3898 24.1948 14.5763 24.1948H21.8644C24.0508 24.1948 25.5085 23.1015 25.5085 20.5507V16.7317C25.5085 16.2507 25.042 15.8863 24.5756 16.0393ZM20.7857 17.3804L19.9257 18.0654C19.4447 18.4517 18.8325 18.6412 18.2203 18.6412C17.6081 18.6412 16.9886 18.4517 16.5149 18.0654L14.2337 16.2434C14.0005 16.0539 13.9641 15.7041 14.1463 15.4709C14.3357 15.2376 14.6783 15.1939 14.9115 15.3834L17.1927 17.2054C17.7466 17.65 18.6868 17.65 19.2407 17.2054L20.1007 16.5204C20.3339 16.3309 20.6837 16.3673 20.8659 16.6078C21.0554 16.841 21.019 17.1909 20.7857 17.3804Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3e61331f55d61aff08047728aeb455b3.svg";
export { ForwardRef as ReactComponent };